<template>
  <div class="container">
    <el-card class="search-card">
      <el-row style="height:40px">
        <el-col :span="12">
          <el-form :inline="true" :model="searchParams">
            <el-form-item>
              <el-input placeholder="请输入用户Id" type="text" size="small" v-model="searchParams.userId"
                class="small" clearable>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-input placeholder="请输入android ID" type="text" size="small" style="width: 250px"
                v-model="searchParams.androidId" class="small" clearable>
              </el-input>
            </el-form-item>
            <el-form-item>
            <el-button
              type="primary"
              size="small"
              style="margin-left: 20px"
              icon="el-icon-search"
              @click="changePage(1)">搜索</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </el-card>
    <el-card style="margin: 0 10px">
      <el-pagination
        v-if="tableData.length > 0"
        layout="prev, pager, next"
        :total="totalCount"
        :page-size="limit"
        style="float: right; margin: 0 0 20px 0"
        @current-change="changePage">
      </el-pagination>
      <el-table :data="tableData">
        <el-table-column
          v-for="col of tableColumns"
          :key="col.prop"
          :prop="col.prop"
          :label="col.label"
          :width="col.width">
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="80">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="view(scope.row)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-dialog
      title="事件详情"
      :visible.sync="detailDialogVisible"
      width="40%"
      :before-close="handleClose">
       <vue-json-pretty :data="selectedRow" > </vue-json-pretty>
    </el-dialog>
  </div>
</template>
<script>

import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';


const tableColumns = [
  { prop: 'id', label: 'Id', width: 80 },
  { prop: 'app_id', label: 'AppId', width: 100},
  { prop: 'user_id', label: 'UserId', width: 100 },
  // { prop: 'typeName', label: 'Type', width: 80 },
  { prop: 'os_type_name', label: 'OsType', width: 100 },
  { prop: 'sdk_version', label: 'SdkVersion', width: 80 },
  { prop: 'app_version', label: 'AppVersion', width: 120 },
  // { prop: 'avatar', label: 'Avatar', width: 100 },
  { prop: 'device_id', label: 'DeviceId', width: 180 },
  { prop: 'media_drm_id', label: 'MediaDrmId', width: 200 },
  { prop: 'guid', label: 'Guid', width: 180 },
  { prop: 'android_id', label: 'AndroidId', width: 150 },
  { prop: 'channel', label: 'Channel', width: 120 },
  { prop: 'install_ip', label: 'InstallIp', width: 150 },
  { prop: 'active_ip', label: 'ActiveIp', width: 150 },
  { prop: 'lat', label: 'Lat', width: 120 },
  { prop: 'lng', label: 'Lng', width: 120 },
  { prop: 'country', label: 'Country', width: 80 },
  // { prop: 'created_ip', label: 'CreatedIp', width: 150 },
  { prop: 'installed_at', label: 'InstalledAt', width: 200 },
  { prop: 'started_at', label: 'StartedAt', width: 200 },
  { prop: 'created_at', label: 'CreatedAt', width: 200 },
  { prop: 'updated_at', label: 'UpdatedAt', width: 200 },
]

const osTypeMap = {
  1: 'Android',
  2: 'IOS',
  4: 'Web',
}

export default {
  components: {
    VueJsonPretty,
  },
  data() {
    return {
      page: 1,
      limit: 15,
      apps: [],
      searchParams: {
        userId: '',
        androidId: '',
      },
      tableData: [],
      totalCount: 0,
      tableColumns: tableColumns,
      selectedRow: undefined,
      detailDialogVisible: false
    }
  },
  mounted() {
  },
  methods: {
    async searchUsers(page) {

      let offset = (page - 1) * this.limit

      let url = `/etp/v1.0/device_reg/list?app_id=${this.$store.state.appId}&limit=${this.limit}&offset=${offset}`;

      let userId = this.searchParams.userId.trim();
      let androidId = this.searchParams.androidId.trim();
      
      if (userId) {
        url = url + `&user_id=${userId}`
      }

      if (androidId) {
        url = url + `&android_id=${androidId}`;
      }

      let rst = await this.$http.get(url);

      let devices = rst.data.data;
      devices.forEach((device) => {
        device.os_type_name = osTypeMap[device.os_type];
        device.installed_at = new Date(device.installed_at).toISOString();
        device.started_at = new Date(device.started_at).toISOString();
      })

      this.tableData = devices;
      this.totalCount = rst.data.total;

    },
    changePage(val) {
      this.searchUsers(val);
    },
    handleClose() {
      this.detailDialogVisible = false;
    },
    view(row) {
      this.selectedRow = row;
      this.detailDialogVisible = true;
    }
  }
}

</script>
<style lang="less" scoped>
  .search-card {
    margin: 10px;
  }

  .small {
    width: 200px;
  }
</style>
